<template>
  <v-container fluid>
    <Breadcrumbs :history="history" />
    <v-card>
      <v-card-text>
        <v-data-table
          elevation-1
          :headers="headers"
          :items="orders"
          @refresh="refresh"
          :loading="isLoading"
          :expanded.sync="expanded"
          show-expand
          item-key="id"
          :search="search"
          sort-by="created"
          :sort-desc="true"
        >
          <template v-slot:top>
            <v-row>
              <v-col cols="4" class="mt-1">
                <div class="text-h5"></div>
              </v-col>
              <v-col cols="4">
                <v-row>
                  <v-col cols="6">
                    <DatePicker
                      label="From" v-model="start" :filled="false" @input="refresh" />
                  </v-col>
                  <v-col cols="6">
                    <DatePicker
                      label="To" v-model="end" :filled="false" @input="refresh" />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  clearable
                  data-cy="TableBasic-search"
                  class="mr-2"
                  v-model="search"
                  :append-icon="mdiMagnify"
                  :label="$t('common.search')"
                  single-line
                  hide-details
                />
              </v-col>
              <v-col cols="1">
                <v-btn class="mt-3 float-right"
                  icon color="primary" @click="$emit('refresh')">
                  <v-icon>{{ mdiRefresh }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.created="{ item }">
            {{ formatDateTime(item.created) }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" style="padding: 10px">
              <v-data-table
                :headers="lineHeaders"
                :items="item.lines"
                elevation-0
                :items-per-page="-1"
                hide-default-footer
              >
              </v-data-table>
            </td>
          </template>
          <template v-slot:item.updated="{ item }">
            {{ formatDateTime(item.updated) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-btn
                small
                color="success"
                class="mr-2 mb-2"
                @click="requeue(item)"
                :loading="item.isSaving"
              >
                Send to D2
              </v-btn>
              <ViewOrderLog :order="item" />
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mdiMagnify, mdiRefresh } from '@mdi/js';
import dayjs from 'dayjs';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import DatePicker from '~src/components/DatePicker.vue';
import ViewOrderLog from '../components/ViewOrderLog.vue';

export default {
  name: 'AdminOrders',
  components: {
    DatePicker,
    ViewOrderLog,
  },
  mixins: [loading],
  data() {
    return {
      mdiMagnify,
      mdiRefresh,
      expanded: [],
      search: '',
      history: [{
        text: 'Home',
        disabled: false,
        href: '/#/members',
        depth: 0,
      }, {
        text: 'Orders',
        disabled: true,
        depth: 0,
      }],
      orders: [],
      start: dayjs().add(-1, 'day').format('YYYY-MM-DD'),
      end: dayjs().add(1, 'day').format('YYYY-MM-DD'),
      lineHeaders: [
        {
          text: 'Quantity',
          value: 'quantity',
        },
        {
          text: 'Item Code',
          value: 'stockItem.itemCode',
        },
        {
          text: 'Description',
          // align: 'start',
          // sortable: false,
          value: 'stockItem.description',
        },
        {
          text: 'D2 Product ID',
          value: 'productId',
        },
      ],
      headers: [
        {
          text: 'Created',
          value: 'created',
        },
        {
          text: 'Status',
          // align: 'start',
          // sortable: false,
          value: 'status',
        },
        {
          text: 'Order ID',
          value: 'externalOrderNo',
        },
        {
          text: 'Customer',
          value: 'customer',
        },
        {
          text: 'Customer Order No',
          value: 'orderNo',
        },
        {
          text: 'Created By',
          value: 'createdBy',
        },
        {
          text: 'Last Updated',
          value: 'updated',
        },
        {
          text: '',
          value: 'actions',
        },
      ],
    };
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    /**
     * Executes refresh
     */
    async refresh() {
      this.isLoading = true;
      const { start, end } = this;
      const { data } = await this.$http.get(`/api/orders/all?start=${start}&end=${end}`);
      this.orders = data.map((order) => ({
        ...order,
        isSaving: false,
      }));
      this.isLoading = false;
    },
    /**
     * Send post to orders api using the order id
     */
    async requeue(item) {
      this.orders[this.orders.indexOf(item)].isSaving = true;
      const result = await this.$confirm('Are you sure you  want to send this order to D2? This will create another order if a previous one exists');
      if (result) {
        try {
          this.isLoading = true;
          await this.$http.post(`/api/orders/${item.id}/requeue`);
          this.$root.$emit('toast:notify', 'Queued for D2');
        } catch (error) {
          this.$log.error(error);
          this.$root.$emit('toast:error', 'Error sending to D2');
        } finally {
          this.isLoading = false;
          this.orders[this.orders.indexOf(item)].isSaving = false;
          await this.refresh();
        }
      } else {
        this.orders[this.orders.indexOf(item)].isSaving = false;
      }
    },
  },
};
</script>
<style scoped>
.table-line {
  width: 100%;
  border-collapse: collapse;
}
</style>
